import { render } from "./StakeHelp.vue?vue&type=template&id=2ca5e01a&scoped=true&ts=true"
import script from "./StakeHelp.vue?vue&type=script&lang=ts"
export * from "./StakeHelp.vue?vue&type=script&lang=ts"

import "./StakeHelp.vue?vue&type=style&index=0&id=2ca5e01a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca5e01a"]])

export default __exports__